import React from "react";

const NavBar = () => null;

export default NavBar;
